import React from 'react';
import { Box, Typography } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';
import { useFeatureFlags } from '../../../../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../../../../flags';
import HereMaps from '../../../common/HereMaps';
import { usePreviewMap } from '../hooks';
import { FALLBACK_HERE_API_KEY } from '../../../../config';

interface PreviewMapProps {
  height?: ResponsiveStyleValue<number | string>;
  zoom?: number;
}

const PreviewMap: React.FC<PreviewMapProps> = ({ height = 400, zoom = 15 }) => {
  const { latitude, longitude, hasCoordinates } = usePreviewMap();
  const { getFeatureValue } = useFeatureFlags();

  const configOverride = getFeatureValue(FeatureFlags.NGW_CONFIG_OVERRIDE) as
    | { HERE_API_KEY?: string }
    | undefined;
  const apiKey =
    configOverride?.HERE_API_KEY ||
    process.env.REACT_APP_HERE_API_KEY ||
    FALLBACK_HERE_API_KEY;

  if (!hasCoordinates || !apiKey) {
    return (
      <Box
        sx={{
          height,
          bgcolor: 'grey.100',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 1,
        }}
      >
        <Typography color="text.secondary">Map not available</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height,
        '& .H_copyright': {
          fontSize: {
            xs: '5px',
            sm: '7px',
            md: 'inherit',
          },
        },
        '& .H_logo': {
          display: {
            xs: 'none !important',
            md: 'block',
          },
        },
        '& .H_overlay.H_el.H_open': {
          zIndex: 1000,
        },
      }}
    >
      <HereMaps
        apiKey={apiKey}
        latitude={latitude}
        longitude={longitude}
        height={height}
        disableDragging={true}
        showInfoCard={false}
        onLocationChange={() => {}}
        zoom={zoom}
      />
    </Box>
  );
};

export default React.memo(PreviewMap);
